module.exports = __webpack_public_path__ + "static/media/cq_utente.b8cdc82c.svg";